import { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Header from '../Header';
import Footer from '../Footer';
import wallpaperResidential from '../../src/image/wallpaper-residential.jpg';
import './theme.css';
import Breadcrumbs from './Breadcrumbs';
function WallPapers() {
    useEffect(() => {
        AOS.init({ duration: 1000, once: true });
    }, []);

    const keyFeatures = [
        { icon: 'bi-check-circle-fill', desc: 'Premium, imported and locally-sourced wallpaper materials' },
        { icon: 'bi-check-circle-fill', desc: 'Professional surface preparation and bubble-free installation' },
        { icon: 'bi-check-circle-fill', desc: 'Acoustic and thermal options available for specific needs' },
        { icon: 'bi-check-circle-fill', desc: 'Customized digital printing for branding and creative walls' },
        { icon: 'bi-check-circle-fill', desc: 'Suitable for residential, commercial and industrial projects' },
    ]

    const features = [
        { title: 'Huge Variety of Patterns & Designs', desc: 'Modern, classic, textured, 3D, kids themes, and more.' },
        { title: 'Professional Installation', desc: 'Clean finishing with edge alignment and expert surface preparation.' },
        { title: 'Suitable for All Interior Types', desc: 'Perfect for residential homes, commercial interiors, and industrial walls requiring design or branding.' }
    ];

    const typesOfWallpapers = [
        { icon: 'bi-check-circle-fill', title: 'Vinyl Wallpapers', desc: 'Moisture-resistant and easy to clean — perfect for high-traffic and damp areas.' },
        { icon: 'bi-check-circle-fill', title: '3D & 4D Wallpapers', desc: 'Adds depth and drama to feature walls in residential and commercial spaces.' },
        { icon: 'bi-check-circle-fill', title: 'Kids Theme Wallpapers', desc: 'Safe, colourful designs tailored for children\'s bedrooms and play areas.' },
        { icon: 'bi-check-circle-fill', title: 'Custom / Digital Print Wallpapers', desc: 'Branding, murals, bespoke art walls and creative installations — fully customizable.' }
    ];

    return (
 <div className="container-fluid p-0 ">
            <Header />

            <section className="theme-section">
                <Breadcrumbs/>
                <div className="container" data-aos="fade-up">
                    <div className="theme-section-title text-center">
                        <h2>Premium Wallpapers for Residential, Commercial & Industrial Interiors</h2>
                        <p>Give your walls a stunning transformation with our wide range of <strong>high-quality
                            wallpapers</strong> designed for every type of interior. We supply and install <strong>all
                                kinds of wallpapers</strong> suitable for <strong>homes, apartments, offices, commercial spaces, hotels, showrooms, institutions, hospitals, and even industrial environments</strong>.</p>
                    </div>

                    <div className="features">
                        {features.map((feature, idx) => (
                            <div key={idx} className="feature" data-aos="fade-up">
                                <h4>{feature.title}</h4>
                                <p className="small muted">{feature.desc}</p>

                            </div>
                        ))}
                    </div>

                    {/* Tab Content */}
                    <div className="theme-row" data-aos="fade-up">
                        <div className="col-lg-6 theme-col">
                            <h6>Key Features</h6>
                            <ul className="theme-features">
                                {keyFeatures.map((item, idx) => (
                                    <li key={idx}>
                                        <i className={`bi ${item.icon}`}></i> {item.desc}
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="col-lg-6 theme-col theme-image-wrapper" data-aos="zoom-in">
                            <img src={wallpaperResidential} alt="Blinds" className="theme-image" />
                        </div>
                    </div>

                    
                        <div className='theme-row' data-aos="fade-up">
                            <div className="theme-col">
                                <h6>Types of Wallpapers We Offer</h6>
                                <ul className="theme-features">
                                    {
                                        typesOfWallpapers.map((item, idx) => (
                                            <li key={idx}>
                                                <i className={`bi ${item.icon}`}></i>
                                                <span>{item.title}:</span> {item.desc}
                                            </li>
                                        ))}
                                </ul>
                            </div>
                        </div>
                  

                    <div className='theme-row' data-aos="fade-up">
                        <div className='theme-row'>
                            <div className="theme-col">
                                <h6>Where Our Wallpapers Are Ideal</h6>
                                <p className='muted small'>Perfect solutions for both residential and commercial projects.</p>
                                <div className='ideal-places'>
                                    <div className="chip">Homes & Apartments</div>
                                    <div className="chip">Corporate Offices</div>
                                    <div className="chip">Retail Shops & Showrooms</div>
                                    <div className="chip">Restaurants, Cafés & Hotels</div>
                                    <div className="chip">Schools & Educational Institutions</div>
                                    <div className="chip">Hospitals & Clinics</div>
                                    <div className="chip">Industrial & Branding Walls</div>
                                    <div className="chip">Conference Rooms & Reception Areas</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Feature Boxes */}
                    <div className="row theme-feature-section" data-aos="fade-up">
                        <div className="theme-feature-box">
                            <p className="theme-feature-description">“Beautiful, durable, and professionally installed — our wallpapers bring style, character, and comfort to every interior space.”</p>
                        </div>
                    </div>

                </div>
            </section>

            <Footer />
        </div>
    );
}

export default WallPapers;
